/* eslint-disable react/prop-types, camelcase */
import { useState } from 'react';
import CalendarSelectableStore from './store';
import dayjs from '@/helpers/dayjs';
import PeriodPopover from './periodPopover';

function ChoiceByDay({
  item, diary = [],
  calendarCurrent = {},
  spaceCalendar = [],
  partnerUntil = 0,
  dataByCategory,
}) {
  const [allow_halfday] = useState(!!dataByCategory?.allow_halfday);
  const [allow_night] = useState(!!dataByCategory?.allow_night);

  const [openPopover, setOpenPopover] = useState(false);

  const dateCurrent = dayjs(item.date);

  function fnDateIsDisable() {
    // datecurrent isover
    if (CalendarSelectableStore.isPast(dateCurrent)) return true;
    // datecurrent isn't same current month
    if (!dateCurrent.isSame(calendarCurrent.date, 'months')) return true;
    // day of week not filled
    const day = dayjs(dateCurrent).locale('en').format('ddd').toLowerCase();
    return !(spaceCalendar || []).find((sc) => sc.day === day);
  }

  function fnPeriodAvailable() {
    const available = {
      d: true, m: 'disable', a: 'disable', n: 'disable', disabled: {},
    };
    // config space by category allow halfday
    if (allow_halfday) {
      available.m = true;
      available.a = true;
    }
    // config space by category allow night
    if (allow_night) {
      available.n = true;
    }

    if (diary && diary.length) {
      const bookings = diary.filter((d) => d.dateKey === dateCurrent.formatAsKey());
      if (bookings) {
        // check if we have paid booking in different period for a day
        const bookingNight = bookings.find((bk) => bk.period === 3);
        const bookingDay = bookings.find((bk) => bk.period === 0);
        const bookingMorning = bookings.find((bk) => bk.period === 1);
        const bookingAfternoon = bookings.find((bk) => bk.period === 2);

        // a booking all day or morning and afternoon, day is full
        if (bookingDay || (bookingMorning && bookingAfternoon)) {
          available.disabled.day = true;
          available.d = false;
          available.m = false;
          available.a = false;
        } else {
          /*
            has a booking at morning
            mean no all day and morning anymore
          */
          if (bookingMorning) {
            available.disabled.morning = true;
            available.d = false;
            available.m = false;
          }
          /*
            has a booking at afternoon
            mean no all day and afternoon anymore
          */
          if (bookingAfternoon) {
            available.disabled.afternoon = true;
            available.d = false;
            available.a = false;
          }
        }
        // no night
        if (bookingNight) {
          available.disabled.night = true;
          available.n = false;
        }

        if (bookingNight && bookingMorning && bookingAfternoon) {
          available.d = false;
          available.disabled = true;
        }

        // different ways why a day will be disable for selecting
        if (
          (bookingMorning && bookingAfternoon && available.n === 'disable')
          || (bookingDay && available.n === 'disable')
          || (bookingNight && bookingDay)
          || (bookingNight && bookingMorning && bookingAfternoon)) {
          available.disabled = true;
        }
      }
    }
    if (available.disabled !== true) {
      available.disabled = Object.keys(available.disabled).join(' ');
    }

    return available;
  }

  function fnDateIsSelected() {
    return CalendarSelectableStore.getDatesPicked().indexOf(dateCurrent.formatAsKey()) > -1;
  }
  // garbage function, juste for dev
  function getPeriodDateCurrent() {
    return CalendarSelectableStore.getPeriod()[dateCurrent.formatAsKey()];
  }

  function onClickOpenPopover() {
    setOpenPopover(true);
  }

  const periodAvailableRes = fnPeriodAvailable();

  function renderPopover(periodAvailable) {
    if (!openPopover) return null;
    return (
      <PeriodPopover
        {...{
          item,
          periodAvailable,
          allow_night,
          allow_halfday,
        }}
        onClose={() => {
          setOpenPopover(false);
        }}
      />
    );
  }

  // if no available period => day disable, else check fnDateIsDisable
  const dateIsDisable = !(periodAvailableRes.disabled !== true) || fnDateIsDisable();
  const dateIsSelected = fnDateIsSelected();
  const classes = `cursor-pointer relative day text-center ${periodAvailableRes.disabled === true ? '' : periodAvailableRes.disabled}`;

  return (
    <td
      data-selected={dateIsSelected}
      data-disabled={dateIsDisable}
      className={classes}
    >
      <div className="flex items-center justify-center">
        <div
          className={`flex period-${getPeriodDateCurrent()} items-center justify-center h-9 w-9 block rounded-lg hover:bg-purple-0
          ${openPopover ? 'bg-purple-0' : ''} ${dateIsDisable ? 'text-purple-2 bg-white' : ''}`}
          {...(dateIsDisable ? {} : { onClick: () => onClickOpenPopover() })}
        >
          <span>
            {dateCurrent.date()}
            {dateIsSelected}
          </span>
        </div>
      </div>
      {renderPopover(periodAvailableRes)}
    </td>
  );
}

export default ChoiceByDay;
